var map = {
	"./Logo.png": 28,
	"./feuille_1.png": 29,
	"./feuille_2.png": 30,
	"./feuille_3.png": 31,
	"./flags/be.svg": 32,
	"./flags/cn.svg": 33,
	"./flags/de.svg": 34,
	"./flags/es.svg": 35,
	"./flags/fr.svg": 36,
	"./flags/gb.svg": 37,
	"./flags/it.svg": 38,
	"./flags/jp.svg": 39,
	"./flags/us.svg": 40,
	"./icons/Flèche.svg": 41,
	"./icons/arrow-white-circle-blue.svg": 42,
	"./icons/arrow-wine.svg": 43,
	"./icons/arrow.svg": 44,
	"./icons/back.svg": 45,
	"./icons/close.svg": 46,
	"./icons/error.svg": 47,
	"./icons/facebook.svg": 48,
	"./icons/info.svg": 49,
	"./icons/instagram.svg": 50,
	"./icons/linkedin.svg": 51,
	"./icons/marker.svg": 52,
	"./icons/menu-arrow.svg": 53,
	"./icons/pinterest.svg": 54,
	"./icons/slider-arrow.svg": 55,
	"./icons/success.svg": 56,
	"./icons/twitter.svg": 57,
	"./icons/weibo.svg": 58,
	"./icons/youtube.svg": 59,
	"./logo-black.png": 60,
	"./logo.svg": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;